import { EntryMethod } from 'src/common/enumerations/entry-method';
import { EwicEpsPrescriptionData } from 'src/devices/payment/dtos/eps-data';
import { TenderParameters } from 'src/tendering/interfaces/tender-parameters';
import { TenderType } from '../../enumerations/tender-type';

interface TenderData {
  tenderId?: string;
  tenderType?: TenderType;
  entryMethod?: EntryMethod;
  cancel?: boolean;
  cancelReason?: string;
  currency?: string;
  processedByEps?: boolean;
  extendedPaymentParameters?: TenderParameters[];
  endorsementPrinted?: boolean;
  usage?: PaymentUsage | RefundUsage;
  expirationDate?: string;
}

interface AmountData {
  amount?: number;
  amountEntryMethod?: EntryMethod;
  preTenderAmount?: number;
  cashBack?: number;
  requestedAmount?: number;
}
export interface ReceiptPreferences {
  printReceipt?: boolean;
  emailAddress?: string;
  phoneNumber?: string;
  deliveryMethod?: string;
}
export interface CardData {
  cardType?: string;
  entryMethod?: string;
  maskedAccountNumber?: string;
  merchantReceipt?: string[];
  customerReceipt?: string[];
  cardCode?: string;
  extendedData?: {};
}
interface Authorization {
  epsName?: string;
  forceOnline?: boolean;
  authorizationMethod?: string;
  referenceNumber?: string;
  isSoftDeclined?: boolean;
  authorizationCode?: string;
  responseCode?: string;
  merchantNumber?: string;
  signatureRequiredFlag?: boolean;
}
export interface EPSData {
  card?: CardData;
  authorization?: Authorization;
  isFallback?: boolean;
  isSmartCardDeclinedByTerminal?: boolean;
  customerSignatureRejectedByCashier?: boolean;
  thirdPartySessionId?: string;
  sessionTranID?: string;
  status?: string;
  providerData?: string;
}

export interface ITenderAdd {
  tender?: TenderData;
  amount?: AmountData;
  epsData?: EPSData;
  receiptPreferences?: ReceiptPreferences;
  typeCode?: RefundUsage;
  ewicEpsPrescriptionData?: EwicEpsPrescriptionData;
  lineId?: number;
  usage?: PaymentUsage | RefundUsage;
}

export enum RefundUsage {
  Refund = 'Refund',
  Change = 'Change',
  ExchangeReceive = 'ExchangeReceive',
}

export enum PaymentUsage {
  Payment = 'Payment',
  Rounding = 'Rounding',
  Deposit = 'Deposit',
  ExchangePay = 'ExchangePay',
  Voided = 'Voided',
  Reward = 'Reward',
  ExchangeReceive = 'ExchangeReceive',
}
